<button mat-icon-button [matMenuTriggerFor]="profileMenu">
    <mat-icon class="icon" svgIcon="account"></mat-icon>
</button>

<mat-menu #profileMenu="matMenu">
    <div mat-menu-item [disabled]="true" class="fx-row fx-layout-align-start-center">
        <mat-icon class="icon" svgIcon="account-circle"></mat-icon>

        <div
            *ngIf="{
                organizationName: organizationName$ | async,
                userName: userName$ | async,
                isImpersonated: isImpersonated$ | async,
                impersonatedAs: impersonatedAs$ | async,
            } as data"
            class="fx-column"
        >
            <div class="login-name"><span i18n="Profile menu|">Logged in as </span> {{ data.userName }}</div>
            <div class="login-details">
                <p>
                    <b>{{ data.organizationName }}</b>
                </p>
                <p *ngIf="data.isImpersonated">
                    <b i18n="Profile menu|Privileges when impersonating">Privileges:</b>
                    {{ data.impersonatedAs.systemRolesString }}
                </p>
            </div>
        </div>
    </div>
    <div
        *ngIf="canImpersonate && !isImpersonated"
        mat-menu-item
        (click)="impersonate()"
        (keydown.enter)="impersonate()"
        class="fx-row fx-layout-align-start-center"
    >
        <mat-icon class="icon" svgIcon="account-arrow-right"></mat-icon>
        <div i18n="Profile menu|">Switch organization</div>
    </div>
    <div
        *ngIf="isImpersonated"
        mat-menu-item
        (click)="backToMyOrganization()"
        (keydown.enter)="backToMyOrganization()"
        class="fx-row fx-layout-align-start-center"
    >
        <mat-icon class="icon" svgIcon="account-arrow-left"></mat-icon>
        <div i18n="Profile menu|">Back to my organization</div>
    </div>
    <div
        mat-menu-item
        (click)="customerPrivacyFilterClick($event)"
        (keydown.enter)="customerPrivacyFilterClick($event)"
        *ngIf="isSystemAdmin"
        class="fx-row fx-layout-align-start-center"
    >
        <mat-icon class="icon" svgIcon="security"></mat-icon>
        <div><span i18n="Profile menu|">Customer privacy filter: </span>{{ customerPrivacy$ | async }}</div>
    </div>
    <div
        mat-menu-item
        (click)="gdprPrivacyFilterClick($event)"
        (keydown.enter)="gdprPrivacyFilterClick($event)"
        *ngIf="isSystemAdmin"
        class="fx-row fx-layout-align-start-center"
    >
        <mat-icon class="icon" svgIcon="m-visibility"></mat-icon>
        <div><span i18n="Profile menu|">GDPR privacy filter: </span>{{ gdprPrivacy$ | async }}</div>
    </div>
    <div
        mat-menu-item
        (click)="openFeatureFlags()"
        (keydown.enter)="openFeatureFlags()"
        *ngIf="showFeatureFlagLink"
        class="fx-row fx-layout-align-start-center"
    >
        <mat-icon class="icon" svgIcon="tune"></mat-icon>
        <div i18n="Profile menu|">Feature Flags</div>
    </div>
    <div
        mat-menu-item
        *ngIf="gaDomain !== ''"
        (click)="modifyCookieConsent()"
        (keydown.enter)="modifyCookieConsent()"
        class="fx-row fx-layout-align-start-center"
    >
        <mat-icon class="icon" svgIcon="m-cookie"></mat-icon>
        <div i18n="Profile menu|">Cookie consent</div>
    </div>
    <div
        mat-menu-item
        *ngIf="gaDomain == ''"
        (click)="localhostErrorPopup()"
        (keydown.enter)="localhostErrorPopup()"
        class="fx-row fx-layout-align-start-center"
    >
        <mat-icon class="icon" svgIcon="m-cookie"></mat-icon>
        <div i18n="Profile menu|">Cookie consent</div>
    </div>
    <div
        mat-menu-item
        (click)="navigateToBillingDashboard()"
        (keydown.enter)="navigateToBillingDashboard()"
        *ngIf="showBillingDashboard$ | async"
        class="fx-row fx-layout-align-start-center"
    >
        <mat-icon class="icon" svgIcon="currency-usd"></mat-icon>
        <div><span i18n="Profile menu|">Billing dashboard</span></div>
    </div>

    <div
        mat-menu-item
        (click)="stopClickPropagate($event)"
        (keydown.enter)="stopClickPropagate($event)"
        style="padding: 0"
        class="fx-row fx-layout-align-start-center"
    >
        <mat-accordion hideToggle>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <div class="fx-row fx-layout-align-start-center">
                        <mat-icon class="icon" svgIcon="web"></mat-icon>
                        <div i18n="Profile menu|Language selection">Language</div>
                    </div>
                </mat-expansion-panel-header>
                <div
                    *ngFor="let language of AVAILABLE_LANGUAGES"
                    mat-menu-item
                    [disabled]="currentLanguage === language.value"
                    (click)="triggerLanguageChange(language.value)"
                    (keydown.enter)="triggerLanguageChange(language.value)"
                    [title]="language.languageName"
                >
                    {{ language.nativeName }}
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <div
        mat-menu-item
        (click)="logout()"
        (keydown.enter)="logout()"
        data-testid="logout"
        class="fx-row fx-layout-align-start-center"
    >
        <mat-icon class="icon" svgIcon="logout"></mat-icon>
        <div i18n="Profile menu|">Log out</div>
    </div>
</mat-menu>
